import { GOAL_REAL_YIELD } from "web_myplann/Goals/constants";
import { monthsUntil } from "web_myplann/Goals/Helpers/monthsUntil";
import { requiredMonthlySavings } from "web_myplann/Goals/Helpers/requiredMonthlySavings";

export const monthlyContribution = (
	savingsTarget: number,
	dueDate: Date | undefined | null,
	annualRate: number = GOAL_REAL_YIELD,
): number =>
	Math.round(
		requiredMonthlySavings(savingsTarget, annualRate, monthsUntil(dueDate)),
	);
